module.exports = __webpack_public_path__ + "static/img/right-home-row-7.5f167a0e.webp";